import AuthAxios from '@/lib/api/axios/AuthAxios'
import { ENDPOINT_BASE } from '@/config/endpoints'

const CYCLES_BASE = `${ENDPOINT_BASE}/e`

const cyclesEndpoint = (env: string) => `${CYCLES_BASE}/${env}/cycles`

export interface GenerateCyclesRequest {
  startDate: string
  durationWeeks: number
  count: number
  namePrefix: string
}

export interface GenerateCyclesResponse {
  cycleIds: Array<string>
}

export const generateCycles = async (
  env: string,
  projectId: string,
  request: GenerateCyclesRequest,
): Promise<GenerateCyclesResponse> => {
  const response = await AuthAxios.post<GenerateCyclesResponse>(
    `${cyclesEndpoint(env)}/${projectId}/generate`,
    request,
  )
  return response.data
}

export interface ActivateCycleResponse {
  success: boolean
}

export const activateCycle = async (
  env: string,
  cycleId: string,
): Promise<ActivateCycleResponse> => {
  const response = await AuthAxios.post<ActivateCycleResponse>(
    `${cyclesEndpoint(env)}/${cycleId}/activate`,
  )
  return response.data
}

export interface CompleteCycleRequest {
  incompleteAction: 'carry_over' | 'backlog'
  nextCycleId?: string
}

export interface CompleteCycleResponse {
  id: string
  code: string
  carriedOverCount?: number
}

export const completeCycle = async (
  env: string,
  cycleId: string,
  request: CompleteCycleRequest,
): Promise<CompleteCycleResponse> => {
  const response = await AuthAxios.post<CompleteCycleResponse>(
    `${cyclesEndpoint(env)}/${cycleId}/complete`,
    request,
  )
  return response.data
}
